<template>
	<div>
		<svg :width="iconSize" :height="iconSize" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path fill-rule="evenodd" clip-rule="evenodd"
				d="M0 3.625V7.94358C0.829307 7.20133 1.92445 6.75 3.125 6.75H18.75C19.9506 6.75 21.0457 7.20133 21.875 7.94358V6.75C21.875 5.02411 20.4759 3.625 18.75 3.625H13.1472C12.94 3.625 12.7413 3.54269 12.5948 3.39618L10.3851 1.18647C9.94553 0.74693 9.34939 0.5 8.72779 0.5H3.125C1.39911 0.5 0 1.89911 0 3.625ZM21.875 16.125C21.875 17.8509 20.4759 19.25 18.75 19.25H3.125C1.39911 19.25 0 17.8509 0 16.125V11.4375C0 9.71161 1.39911 8.3125 3.125 8.3125H18.75C20.4759 8.3125 21.875 9.71161 21.875 11.4375V16.125ZM17.185 10.3915C16.4117 10.3915 15.7849 11.0184 15.7849 11.7917C15.7849 12.565 16.4117 13.1919 17.185 13.1919C17.9583 13.1919 18.5852 12.565 18.5852 11.7917C18.5852 11.0184 17.9583 10.3915 17.185 10.3915ZM17.185 13.6586C15.7824 13.6586 14.6425 14.7836 14.6184 16.1806C14.6168 16.2732 14.6702 16.3581 14.7544 16.3967C15.4947 16.7364 16.3181 16.9257 17.1851 16.9257C18.0521 16.9257 18.8754 16.7365 19.6156 16.3968C19.6999 16.3582 19.7532 16.2733 19.7517 16.1807C19.7276 14.7836 18.5877 13.6586 17.185 13.6586Z"
				:fill="color" 
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgMemberDirectory',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null
		}
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		}
	}
};
</script>

<style scoped>

</style>